import {getBoolValueFromEnv} from './env'

export const isNewFeatureEnabled = () => getBoolValueFromEnv('REACT_APP_NEW_FEATURE_ENABLED')
